import React, {createContext, useContext, useReducer} from 'react'
import {ZancaSortDeviceOverviewReducer} from "../reducer/ZancaSortDeviceOverviewReducer";
import {PermissionsContext} from "../../../permissions/PermissionsContext";
import PermissionAlertBanner from "../../../commonui/PermissionAlertBanner";

export const ZancaSortDeviceOverviewContext = createContext();

const ZancaSortDeviceOverviewContextProvider = (props) => {
    const data = {
        sortPref: {column: "name", direction: "ascending"},
        zancaSortDeviceInformation: {},
        macAddressArray: [],
        loadingOverview: true
    }
    const [viewModel, dispatch] = useReducer(ZancaSortDeviceOverviewReducer, data)
    const {isAuthorised} = useContext(PermissionsContext);

    if (!isAuthorised){
        return (
            <PermissionAlertBanner/>
        );
    }

    return (
        <ZancaSortDeviceOverviewContext.Provider value={{viewModel, dispatch}}>
            {props.children}
        </ZancaSortDeviceOverviewContext.Provider>
    )
}
export default ZancaSortDeviceOverviewContextProvider


// WEBPACK FOOTER //
// ./src/components/devicemanagement/zancasort/context/ZancaSortDeviceOverviewContext.js